<template>
  <div class="p-search-builder__main">
    <div v-if="fetchLoading">
      ビルダー一覧を取得中...
    </div>

    <div v-else-if="fetchError">
      ビルダー一覧を取得できませんでした。
      <a
        href="javascript:void(0)"
        @click.prevent="fetchBuilders"
      >再取得する</a>
    </div>

    <template v-else>
      <div class="p-search-builder__selectContainer">
        <div class="p-search-builder__select">
          <label class="p-search-builder__label">
            <select
              v-model="prefectureId_"
              class="p-search-builder__select-input"
            >
              <option
                v-for="prefecture in prefectures"
                :key="prefecture.value"
                :value="prefecture.value"
              >
                {{ prefecture.text }}
              </option>
            </select>
          </label>
        </div>
      </div>

      <hr class="p-search-builder__separator">

      <div class="p-search-builder__result">
        <div class="p-search-builder__builder">
          <ul
            v-if="searchBuilders.length"
            class="p-search-builder__list"
          >
            <li
              v-for="(builder, index) in searchBuilders"
              :key="index"
              class="p-search-builder__listItem"
            >
              <component
                :is="builder.url ? 'a' : 'span'"
                :href="builder.url ? builder.url : false"
                :target="builder.url ? '_blank' : false"
                rel="noopener"
                class="p-search-builder__link"
              >
                {{ builder.name }}
              </component>
            </li>
          </ul>
          <p v-else>
            該当のビルダーはいません。
          </p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SearchBuilder',

  props: {
    prefectureId: {
      type: Number,
      default: 1
    },
    builderJsonPath: {
      type: String,
      default: 'https://files.myhm.jp/json/myhm_builders.json'
    }
  },

  data () {
    return {
      prefectures: [
        { text: '北海道', value: 1 },
        { text: '青森県', value: 2 },
        { text: '岩手県', value: 3 },
        { text: '宮城県', value: 4 },
        { text: '秋田県', value: 5 },
        { text: '山形県', value: 6 },
        { text: '福島県', value: 7 },
        { text: '茨城県', value: 8 },
        { text: '栃木県', value: 9 },
        { text: '群馬県', value: 10 },
        { text: '埼玉県', value: 11 },
        { text: '千葉県', value: 12 },
        { text: '東京都', value: 13 },
        { text: '神奈川県', value: 14 },
        { text: '新潟県', value: 15 },
        { text: '富山県', value: 16 },
        { text: '石川県', value: 17 },
        { text: '福井県', value: 18 },
        { text: '山梨県', value: 19 },
        { text: '長野県', value: 20 },
        { text: '岐阜県', value: 21 },
        { text: '静岡県', value: 22 },
        { text: '愛知県', value: 23 },
        { text: '三重県', value: 24 },
        { text: '滋賀県', value: 25 },
        { text: '京都府', value: 26 },
        { text: '大阪府', value: 27 },
        { text: '兵庫県', value: 28 },
        { text: '奈良県', value: 29 },
        { text: '和歌山県', value: 30 },
        { text: '鳥取県', value: 31 },
        { text: '島根県', value: 32 },
        { text: '岡山県', value: 33 },
        { text: '広島県', value: 34 },
        { text: '山口県', value: 35 },
        { text: '徳島県', value: 36 },
        { text: '香川県', value: 37 },
        { text: '愛媛県', value: 38 },
        { text: '高知県', value: 39 },
        { text: '福岡県', value: 40 },
        { text: '佐賀県', value: 41 },
        { text: '長崎県', value: 42 },
        { text: '熊本県', value: 43 },
        { text: '大分県', value: 44 },
        { text: '宮崎県', value: 45 },
        { text: '鹿児島県', value: 46 },
        { text: '沖縄県', value: 47 }
      ],
      builders: [],
      fetchLoading: false,
      fetchError: false
    };
  },

  computed: {
    searchBuilders () {
      return this.builders.filter(
        (builder) => builder.prefecture_id === this.prefectureId
      );
    },

    prefectureId_: {
      get () {
        return this.prefectureId;
      },
      set (value) {
        const prefectureId = Number(value);
        this.$emit('update:prefecture-id', prefectureId);
      }
    }
  },

  mounted () {
    this.fetchBuilders();
  },

  methods: {
    /**
     * @returns {void}
     */
    fetchBuilders () {
      this.fetchLoading = true;
      this.fetchError = false;

      fetch(this.builderJsonPath, {
        method: 'GET',
        mode: 'cors',
        credentials: 'same-origin',
        cache: 'no-store'
      })
        .then((resp) => resp.json())
        .then((builders) => (this.builders = builders))
        .catch((err) => {
          console.log(err);
          this.fetchError = true;
        })
        .finally(() => (this.fetchLoading = false));
    }
  }
};
</script>
